import React, { useState, useEffect } from "react";
import MasterTable from "../common/MasterTable";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";
import Loader from "../Loader/Loader";
import RcsFullStatement from "./RcsFullStatement";
import RcsDownloadReport from "./RcsDownloadReport";
import { format, isValid, parse } from "date-fns";
import RCSHistoryFilterModal from "./RCSHistoryFilterModal";
import RcsNewModal from "./RcsNewModal";
import { useDashboardData } from "../../Hooks/useDashboardData";
import ReportModal from "../smshistory/Report";
import RCSReportTypeModal from "./RcsReportType";

const defaultFilterData = {
  companyId: "",
  mobileNum: "",
  status: [],
  fromDate: "",
  toDate: "",
  operator: [],
  customerName: "",
  campaignId: "",
};

const RcsHistory = () => {
  const loggedInUserName = sessionStorage.getItem("username");
  const { fetchDashboardData } = useDashboardData(loggedInUserName);

  const [noData, setNoData] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [RCSHistoryData, setRCSHistoryData] = useState([]);
  const [modalAction, setModalAction] = useState("");
  const [loading, setLoading] = useState(true);
  const [pageDetails, setPageDetails] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpenRcs, setIsModalOpenRcs] = useState(false);
  const [isModalOpenRcsDown, setIsModalOpenRcsDown] = useState(false);
  const [isModalOpenFilter, setIsModalOpenFilter] = useState(false);
  const [filterData, setFilterData] = useState(defaultFilterData);
  const [isReportModal, setIsReportModal] = useState(false);
  const [isRCSReportTypeModal, setIsRCSReportTypeModal] = useState(false);
  const [reportType, setReportType] = useState("");

  const openModalFilter = () => setIsModalOpenFilter(true);
  const closeModalFilter = () => setIsModalOpenFilter(false);

  const [isModalOpenRcsNew, setIsModalOpenRcsNew] = useState(false);

  const openModalRcsNew = () => setIsModalOpenRcsNew(true);
  const closeModalRcsNew = () => setIsModalOpenRcsNew(false);

  const handleReset = () => {
    setFilterData(defaultFilterData);
    setCurrentPage(1);
  };

  const openModalRcs = () => {
    setIsModalOpenRcs(true);
  };

  const closeModalRcs = () => {
    setIsModalOpenRcs(false);
  };

  const openModalRcsDown = () => {
    setIsModalOpenRcsDown(true);
  };

  const closeModalRcsDown = () => {
    setIsModalOpenRcsDown(false);
  };

  useEffect(() => {
    fetchRCSHistoryData(1, filterData);
  }, []);

  const fetchRCSHistoryData = async (pageNo, filters, actionType) => {
    console.log("::::::filters::::::", filters);

    try {
      const requestBody = {
        username: loggedInUserName,
        companyId: filters.companyId || "",
        campaignId: filters.campaignId || "",
        mobileNum: filters.mobileNum || "",
        status: filters.status || [],
        fromDate: filters.fromDate
          ? format(
              parse(filters.fromDate, "yyyy-MM-dd", new Date()),
              "dd-MM-yyyy"
            )
          : "",
        toDate: filters.toDate
          ? format(
              parse(filters.toDate, "yyyy-MM-dd", new Date()),
              "dd-MM-yyyy"
            )
          : "",
      };
      setLoading(true);

      const baseUrl = apiList.RCS_TRANSACTION_HISTORY;
      const url = `${baseUrl}?pageSize=${pageSize}&pageNo=${pageNo}`;

      const response = await axiosPostApi(url, requestBody, {});

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setPageDetails(response?.data?.pageDetails);
        const transactions = response?.data?.data;
        const modifiedData = modifyStructure(transactions);
        setRCSHistoryData(modifiedData);
        if (actionType === "reload") {
          fetchDashboardData();
        }
        if (modifiedData?.length === 0) {
          setNoData(true);
          CustomAlert({
            title: "No Data",
            text: "No transaction history found for the given criteria.",
            icon: "info",
            confirmButtonText: "OK",
          });
        } else {
          setNoData(false);
        }
        setLoading(false);
      } else {
        setLoading(false);
        setNoData(true);
        setRCSHistoryData([]);
        CustomAlert({
          title: "No Data",
          text:
            response?.data?.responseDescription ||
            "No transaction history found.",
          icon: "info",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching RCS history:", error);
      let errorMessage =
        "An error occurred while fetching the data. Please try again later.";
      if (error.response?.status === 404) {
        errorMessage =
          "The requested endpoint was not found. Please check the API URL or contact support.";
      } else if (error.response?.data?.responseDescription) {
        errorMessage = error.response.data.responseDescription;
      }
      CustomAlert({
        title: error.response?.status === 404 ? "Not Found" : "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
      setNoData(true);
      setRCSHistoryData([]);
    } finally {
      setLoading(false);
    }
  };

  const parseDate = (dateStr) => {
    if (!dateStr) return null;

    const formats = [
      "dd-MM-yyyy HH:mm:ss.SSS", // ✅ milliseconds (3 digits)
      "dd-MM-yyyy HH:mm:ss", // seconds only
    ];

    for (const fmt of formats) {
      const parsed = parse(dateStr, fmt, new Date());
      if (isValid(parsed)) return parsed;
    }

    return null;
  };

  const modifyStructure = (response) => {
    return response?.map((item, index) => {
      const txnDateParsed = item?.txnDate
        ? parse(item.txnDate, "dd-MM-yyyy HH:mm:ss", new Date())
        : null;

      const lastEventDateParsed = parseDate(item?.lastEventTime);

      const responseDateParsed = item?.responseDate
        ? parse(item.responseDate, "dd-MM-yyyy HH:mm:ss", new Date())
        : null;

      const createdDateParsed = item?.createdDate
        ? parse(item.createdDate, "dd-MM-yyyy HH:mm:ss", new Date())
        : null;

      // Parse rcsMessage JSON and filter out null values
      let rcsMessageParsed = {};
      try {
        rcsMessageParsed = JSON.parse(item.rcsMessage || "{}");
        // Remove null fields from rcsMessage
        Object.keys(rcsMessageParsed).forEach((key) => {
          if (rcsMessageParsed[key] === null) {
            delete rcsMessageParsed[key];
          }
        });
      } catch (error) {
        console.error("Error parsing rcsMessage:", error);
        rcsMessageParsed = {};
      }

      return {
        ...item,
        id: index + 1,
        txnDate: txnDateParsed
          ? [
              format(txnDateParsed, "dd-MM-yyyy"),
              <br key={`txn-${index}`} />,
              format(txnDateParsed, "HH:mm:ss"),
            ]
          : "",

        lastEventTime: lastEventDateParsed
          ? [
              format(lastEventDateParsed, "dd-MM-yyyy"),
              <br key={`lastEvent-${index}`} />,
              format(lastEventDateParsed, "HH:mm:ss.SSS"), // ✅ milliseconds only
            ]
          : "",

        responseDate: responseDateParsed
          ? [
              format(responseDateParsed, "dd-MM-yyyy"),
              <br key={`response-${index}`} />,
              format(responseDateParsed, "HH:mm:ss"),
            ]
          : "",
        createdDate: createdDateParsed
          ? [
              format(createdDateParsed, "dd-MM-yyyy"),
              <br key={`created-${index}`} />,
              format(createdDateParsed, "HH:mm:ss"),
            ]
          : "",
        rcsMessage: JSON.stringify(rcsMessageParsed, null, 2), // Pretty-print JSON without null values
      };
    });
  };

  const RCSHistoryHeaders = [
    "Status",
    "Response Description",
    "Campaign Id",
    "Current Balance(Qty)",
    "Txn Date",
    "Last Event Time",
    "Company Id",
    "Company Name",
    "Mobile No",
    "Rcs Message",
    "Message Id",
    "Response Code",
    "Response Date",
    "Created Date",
    "Agent Id",
  ];

  const RCSHistoryHeaderToKeyMap = {
    Status: "status",
    "Response Description": "responseDescription",
    "Campaign Id": "campaignId",
    "Current Balance(Qty)": "currentBalance",
    "Txn Date": "txnDate",
    "Last Event Time": "lastEventTime",
    "Company Id": "companyId",
    "Company Name": "comapnyName",
    "Mobile No": "mobileNum",
    "Rcs Message": "rcsMessage",
    "Message Id": "messageId",
    "Response Code": "responseCode",
    "Response Date": "responseDate",
    "Created Date": "createdDate",
    "Agent Id": "agentId",
  };

  const handlerRCSHistory = (id, actionType = "view") => {
    setModalAction(actionType);
    if (actionType === "add") {
      setEditData({});
      setShowModal(true);
    } else if (actionType === "reload") {
      fetchRCSHistoryData(pageDetails?.pageNo, filterData, actionType);
    } else if (actionType === "report") {
      setIsReportModal(true);
    }
  };

  const pageSizeCount = pageDetails === null ? 0 : pageDetails.pageSize;
  const totalRecord = pageDetails === null ? 0 : pageDetails.totalRecords;

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <>
          <MasterTable
            headers={RCSHistoryHeaders}
            data={RCSHistoryData}
            handleAction={handlerRCSHistory}
            filterFields={["companyId"]}
            entityType="RCS Transaction"
            headerToKeyMap={RCSHistoryHeaderToKeyMap}
            loading={loading}
            pageDetails={pageDetails}
            noData={noData}
            currentPage={currentPage}
            openModalFilter={openModalFilter}
            pageSize={pageSizeCount}
            totalRecord={totalRecord}
            fetchNextData={(pageNo) => fetchRCSHistoryData(pageNo, filterData)}
            setCurrentPage={setCurrentPage}
            openModalRcs={openModalRcs}
            openModalRcsDown={openModalRcsDown}
            openModalRcsNew={openModalRcsNew}
            filterData={filterData}
            setHistoryData={setRCSHistoryData}
            handleReset={handleReset}
            fetchData={() => fetchRCSHistoryData(1, defaultFilterData)}
          />
          {isModalOpenRcsNew && (
            <RcsNewModal
              show={isModalOpenRcsNew}
              handleClose={closeModalRcsNew}
            />
          )}
        </>
      )}
      {isModalOpenFilter ? (
        <RCSHistoryFilterModal
          show={isModalOpenFilter}
          handleClose={closeModalFilter}
          setFilterData={setFilterData}
          filterData={filterData}
          handleReset={handleReset}
          setHistoryData={setRCSHistoryData}
          setPageDetails={setPageDetails}
          setNoData={setNoData}
          pageSize={pageSize}
          currentPage={currentPage}
        />
      ) : null}

      {isModalOpenRcs ? (
        <RcsFullStatement
          handleopenRcs={isModalOpenRcs}
          handleCloseRcs={closeModalRcs}
        />
      ) : null}
      {isModalOpenRcsDown ? (
        <RcsDownloadReport
          handleopenRcsDown={isModalOpenRcsDown}
          handleCloseRcsDown={closeModalRcsDown}
        />
      ) : null}

      {isRCSReportTypeModal && (
        <RCSReportTypeModal
          show={isRCSReportTypeModal}
          handleClose={() => setIsRCSReportTypeModal(false)}
          reportType={reportType}
          closeReportModal={() => setIsReportModal(false)}
        />
      )}

      {isReportModal ? (
        <ReportModal
          show={isReportModal}
          handleClose={() => {
            setIsReportModal(false);
          }}
          openFullStatement={() => setIsRCSReportTypeModal(true)}
          openModalFilter={() => setIsRCSReportTypeModal(true)}
          reportOptions={[
            { value: "statement", label: "Full Statement" },
            { value: "summary", label: "Summary Report" },
          ]}
          onSubmitReportType={(reportType) => {
            setReportType(reportType);
          }}
        />
      ) : null}
    </div>
  );
};

export default RcsHistory;
